<template>
  <header ref="header">
    <nav class="navbar">
      <div class="navbar-container">
        <div class="navbar-content">
          <router-link class="navbar-logo" to="/">
            <Logo />
          </router-link>
          <a
            class="navbar-menu"
            :class="{ 'is-open': isGlobalMenuOpen }"
            href="#"
            @click.prevent="$store.commit('navbar/toggleGlobalMenu')"
          >
            <span></span>
            <span></span>
            <span></span>
          </a>
          <a class="navbar-mail" :href="staffEmail" v-if="hasMailButton">
            <i class="far fa-envelope text-primary"></i>
          </a>
          <a
            href="#"
            class="navbar-lock category-lock"
            :class="{ 'is-open': isCategoryLockOpen }"
            @click.prevent="$store.commit('navbar/toggleCategoryLock')"
            v-if="hasCategoryLock"
          >
            <i class="fas fa-lock text-primary"></i>
          </a>
          <a
            href="#"
            class="navbar-lock dialog-lock"
            :class="{ 'is-open': isQuestionLockOpen }"
            @click.prevent="$store.commit('navbar/toggleQuestionLock')"
            v-if="hasQuestionLock"
          >
            <i class="fas fa-lock text-primary"></i>
          </a>
        </div>
      </div>
    </nav>

    <Menu />
    <CategoryLock v-if="hasCategoryLock" />
    <QuestionLock v-if="hasQuestionLock" />
  </header>
</template>

<script>
import Menu from './Menu.vue'
import CategoryLock from '../CategoryLock.vue'
import QuestionLock from '../QuestionLock.vue'

export default {
  components: {
    Menu,
    CategoryLock,
    QuestionLock
  },
  data() {
    return {
      menuOpen: false
    }
  },
  computed: {
    isGlobalMenuOpen() {
      return this.$store.state.navbar.isGlobalMenuOpen
    },
    isCategoryLockOpen() {
      return this.$store.state.navbar.isCategoryLockOpen
    },
    isQuestionLockOpen() {
      return this.$store.state.navbar.isQuestionLockOpen
    },
    hasMailButton() {
      if (this.$store.getters['auth/isCustomer']) {
        return (
          this.$store.state.app.hasMailButton
          && this.$store.state.app.staff.email
        )
      }
      return false
    },
    hasCategoryLock() {
      return (
        this.$store.getters['auth/isPlanner'] &&
        this.$route.name === 'business.category.index'
      )
    },
    hasQuestionLock() {
      return (
        this.$store.getters['auth/isPlanner'] &&
        this.$route.name === 'business.question.index'
      )
    },
    staffName() {
      return this.$store.state.app.staff.name
    },
    staffEmail() {
      return 'mailto:' + this.$store.state.app.staff.email
    }
  }
}
</script>
